// getters
export const EVENTS = 'events'
export const TOTAL_PAGES = 'totalPages'
export const ACTUAL_PAGE = 'actualPage'
export const TOTAL_EVENTS = 'totalEvents'
export const USER = 'user'
export const IS_LOGGED_IN = 'isLoggedIn'

// mutations
export const SET_EVENTS = 'setEvents'
export const SET_TOTAL_PAGES = 'setTotalPages'
export const SET_ACTUAL_PAGE = 'setActualPage'
export const SET_TOTAL_EVENTS = 'setTotalEvents'
export const SET_USER = 'setUser'
export const SET_USER_PROFILE = 'setUserProfile'
export const EMPTY_USER = 'emptyUser'
export const UPDATE_USER = 'updateUser'

// actions
export const FETCH_EVENTS = 'fetchEvents'
export const FETCH_USER = 'fetchUser'
export const DELETE_USER = 'deleteUser'
